import React, { createContext, useContext, useEffect, useState } from 'react';

interface SiteConfig {
  complianceMode: boolean;
}

const ConfigContext = createContext<SiteConfig>({ complianceMode: false });

export const useSiteConfig = () => useContext(ConfigContext);

export const ConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<SiteConfig>({ complianceMode: false });

  useEffect(() => {
    fetch('/api/config')
      .then((r) => r.json())
      .then((d) => setConfig({ complianceMode: Boolean(d.complianceMode) }))
      .catch(() => {});
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

/**
 * Associates-compliance banner. Rendered site-wide when compliance mode is on:
 * clear, conspicuous affiliate disclosure as the program requires.
 */
export const ComplianceBanner: React.FC = () => {
  const { complianceMode } = useSiteConfig();
  if (!complianceMode) return null;
  return (
    <div className="bg-earth-900 text-cream-100 text-center text-xs sm:text-sm py-2 px-4" role="note">
      As an Amazon Associate, GoodCart earns from qualifying purchases made through links on this site.
    </div>
  );
};
